import { CustomTextarea } from './CustomTextarea';

export default CustomTextarea;
